<template>
  <div id="CoreBenefits">
    <b-container fluid>
      <b-row>
        <b-col lg="6" md="12" class="player">
          <img src="@/assets/images/player-1.png" alt="Player" />
        </b-col>
        <b-col lg="6" md="12" class="benefitsList">
          <h1>Season Member Benefits</h1>
          <div class="line"></div>
          <!-- <p>Early Access to Tickets</p> -->
          <div id="accordionContainer">
            <Accordion :accordionData="accordionData" />
          </div>
          <b-row class="renewBtn">
            <b-col>
              <a v-scroll-to="'#Renew'">Renew Now</a>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="text-center">
          <p class="smallPrint">Please note, all seat locations, game availability and access to benefits are subject to change. Seating capacity may be restricted and/or vary throughout the 2021 season.</p>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { coreBenefitsData } from "@/data/benefitsData";
import { TweenLite } from "gsap/dist/gsap";
import Accordion from "@/components/sections/CoreBenefits/Accordion";
export default {
  name: "CoreBenefits",
  components: {
    Accordion
  },
  data() {
    return {
      accordionData: coreBenefitsData(),
      selectedCategory: "",
      activeItemKey: ""
    };
  },
  methods: {
    itemClicked(itemId) {
      let currentActiveEle = document.getElementById(this.activeItemKey);
      let activeItemKeyCopy = this.activeItemKey;
      if (currentActiveEle) {
        this.activeItemKey = "";
        TweenLite.to(currentActiveEle, 0.5, {
          height: 0
        });
      }
      if (itemId != activeItemKeyCopy) {
        this.activeItemKey = itemId;
        let newActiveEle = document.getElementById(itemId);
        TweenLite.to(newActiveEle, 0.5, {
          height: newActiveEle.scrollHeight
        });
      }
    }
  },
  mounted() {
    if (this.accordionData && Object.keys(this.accordionData).length > 0) {
      this.selectedCategory = Object.keys(this.accordionData)[0];
    }
  }
}
</script>

<style lang="scss" scoped>
  #CoreBenefits {
    .player {
      padding: 0;
      margin: 0;
      img {
        width: 100%;
      }
    }
    .benefitsList {
      padding-right: 7%;
      h1 {
        font-family: 'UniversLTStd-UltraCn';
        color: $dark-blue;
        font-size: 50px;
        text-transform: uppercase;
        @media only screen and (max-width: $sm) {
          font-size: 42px;
        }
      }
      .line{
        background-color: $yellow;
        width: 190px;
        height: 3px;
        margin: 10px 0;
      }
      p {
        font-family: 'UniversLTStd';
        font-size: 16px;
        color: #000;
        margin: 40px 0 10px 0;
				span {
					font-family: 'UniversLTStd-Bold';
				}
      }
      .renewBtn {
        margin-top: 30px;
        a {
          font-family: 'UniversLTStd-Bold';
          font-size: 16px;
          color: #000;
          background-color: $yellow;
          border-radius: 25px;
          padding: 15px 40px;
          text-transform: uppercase;
          cursor: pointer;
          &:hover {
            text-decoration: none;
          }
        }
      }
    }
    p.smallPrint {
      font-family: 'UniversLTStd-Obl';
      font-size: 12px;
      margin: 50px 0 10px 0;
    }
  }
</style>